/* @flow */
import React, { PureComponent } from 'react'
import Tooltip from 'antd/lib/tooltip'
import {NumberCell, CustomCell, CheckboxCell, RiskCell, risk as riskObj, FundValueCell} from './ListCells'
import { changeColor, cellClassName } from './globals'
import { twoDec } from './utils'
import labels from './labels'
import type {Lang, Mode} from './App'
import Leaf from "./Leaf";
import moment from "moment";

type State = {
    checked: boolean,
    call: boolean
}

type UfkProps = {
  id: string,
  selected: boolean,
  name: string,
  categoryShort: string,
  category: string,
  managerShort: string,
  manager: string,
  code: string,
  valuation: number,
  lastValuationDate: Date,
  d: ?number,
  m: ?number,
  q: ?number,
  y: ?number,
  y3: ?number,
  y5: ?number,
  risk: number,
  uri: string,
  disabled: boolean,
  lang: Lang,
  apiUrl: string,
  width: number,
  grouped: 0 | 1,
  sfdrLevel: ?number,
  mode: Mode,
  addData: (ids: Array<string>, () => void) => void,
  removeData: (ids: Set<string>) => void,
}

export class UfkRow extends PureComponent<UfkProps, State> {
  state = {
    checked: false,
    call: false
  }

  componentDidMount = () => {
    this.setState({ checked: this.props.selected})
  }

  componentWillReceiveProps ({ selected: checked }: UfkProps) {
    checked !== this.state.checked && this.setState({ checked })
  }

  onChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const { addData, removeData } = this.props
    const { name, checked } = e.currentTarget
    if (checked) {
      this.setState({ checked, call: true })
      addData([name], () => {
        this.setState({ call: false })
      })
    } else {
      this.setState({ checked })
      removeData(new Set([name]))
    }
  }

  render () {
    const { id, name, code, category, valuation, lastValuationDate, d, m, q, y, y3, y5, risk, uri, disabled, lang, apiUrl, width, grouped, sfdrLevel, mode } = this.props
    const { checked, call } = this.state
    return (
      <tr>
        <CheckboxCell
          name={id}
          onChange={this.onChange}
          checked={checked}
          disabled={disabled || call}
          lang={lang}
        />
        <NameUfkCell
                content={name}
                {...{ id, code, category, lastValuationDate, valuation, d, m, q, y, y3, y5, risk, uri, lang, apiUrl, width, sfdrLevel} }
        />
        <CustomCell content={code} className={cellClassName(width, 'code')} />
        <CustomCell content={category} className={grouped ? 'hide' : cellClassName(width, 'cat')} />
        <CustomCell content={moment(lastValuationDate).format('L')} className={cellClassName(width, 'lastValuationDate')} />
        <FundValueCell num={valuation} lang={lang} className={cellClassName(width, 'val')} />
        <NumberCell num={d} percent className={cellClassName(width, 'd')} />
        <NumberCell num={m} percent className={cellClassName(width, 'm')} />
        <NumberCell num={q} percent className={cellClassName(width, 'q')} />
        <NumberCell num={y} percent className={cellClassName(width, 'y')} />
        <NumberCell num={y3} percent className={cellClassName(width, 'y3')} />
        <NumberCell num={y5} percent className={cellClassName(width, 'y5')} />
        <RiskCell num={risk} lang={lang} mode={mode} className={cellClassName(width, 'risk')} />
        <CustomCell
          icon
          uri={`${apiUrl}fund/${id}?format=csv`}
          className={cellClassName(width, 'csv')}
          content="download"
          textAlign="center"
          popup={labels[lang].downCSV}
        />
      </tr>
    )
  }
}

type NameUfkProps = {
  id: string,
  code: string,
  content: string,
  uri?: string,
  lang: Lang,
  category: string,
  manager: string,
  valuation: number,
  lastValuationDate: Date,
  d: ?number,
  m: ?number,
  q: ?number,
  y: ?number,
  y3: ?number,
  y5: ?number,
  risk: number,
  apiUrl: string,
  width: number,
  sfdrLevel: ?number,
}

type NameUfkState = {
  displayInfo: boolean
}

export class NameUfkCell extends PureComponent<NameUfkProps, NameUfkState> {
  state = {
    displayInfo: false
  }
  manageDisplayInfo = () => {
    const { displayInfo } = this.state
    this.setState({ displayInfo: !displayInfo })
  }

  renderLeaves() {
      const { sfdrLevel } = this.props;
      const renderLeaves = [];
      for (let i = 0; i < sfdrLevel; i++) {
          renderLeaves.push(<Leaf key={i}/>);
      }
      return renderLeaves;
  }

  render () {
    const { id, code, content, uri = '', category, lastValuationDate, valuation, d, m, q, y, y3, y5, risk, lang, apiUrl, width } = this.props
    const { displayInfo } = this.state
    return (
      <td className={`left aligned name-cell ${cellClassName(width, 'name')}`}>
        {uri
        ? <Tooltip title={labels[lang].showDet}>
          <a
            href={uri}
            target='_blank'
          >
              <span style={{color: "black", "margin-right": "0.5rem"}}>
                {content}
              </span>
              <i aria-hidden="true" className="external icon" style={{color: "#eb1e82"}}></i>
          </a>
        </Tooltip>
        : content}
        {/*{this.renderLeaves()}*/}
        {width < 1200
          && <i
            aria-hidden="true"
            className={`${displayInfo ? 'minus square outline' : 'plus square outline'} link large icon plus-icon`}
            onClick={this.manageDisplayInfo}>
          </i>}
        <InfoUfkCell {...{ category, code, lastValuationDate, valuation, d, m, q, y, y3, y5, risk, lang, width, display: displayInfo, uri: `${apiUrl}fund/${id}?format=csv`}}/>
      </td>
    )
  }
}

type InfoUfkProps = {
  lang: Lang,
  code: string,
  category: string,
  lastValuationDate: Date,
  manager: string,
  d: ?number,
  m: ?number,
  q: ?number,
  y: ?number,
  y3: ?number,
  y5: ?number,
  risk: number,
  display: boolean,
  uri: string,
  width: number
}

export class InfoUfkCell extends PureComponent<InfoUfkProps> {
  render () {
    const { code, category, lastValuationDate, manager, d, m, q, y, y3, y5, risk, lang, display, uri, width} = this.props
    return (
      <div className={`info${display ? ' display' : ''}`}>
        <div className={cellClassName(width, 'code', false)}><span>{labels[lang].codeUfk}: </span><strong><span>{code}</span></strong></div>
        <div className={cellClassName(width, 'cat', false)}><span>{labels[lang].catUfk}: </span><strong><span>{category}</span></strong></div>
        <div className={cellClassName(width, 'date', false)}><span>{labels[lang].lastValuationDateUfk}: </span><strong><span>{moment(lastValuationDate).format('L')}</span></strong></div>
        <div className={cellClassName(width, 'man', false)}><span>{labels[lang].manUfk}: </span><strong><span>{manager}</span></strong></div>
        <div className={cellClassName(width, 'd', false)}>
          <span>{labels[lang].dUfk}: </span>
          <strong><span className={`${changeColor(d)}`}>{d === null ? '-' : `${twoDec(d)}%`}</span></strong>
        </div>
        <div className={cellClassName(width, 'm', false)}>
          <span>{labels[lang].mUfk}: </span>
          <strong><span className={`${changeColor(m)}`}>{m === null ? '-' : `${twoDec(m)}%`}</span></strong>
        </div>
        <div className={cellClassName(width, 'q', false)}>
          <span>{labels[lang].qUfk}: </span>
          <strong><span className={`${changeColor(q)}`}>{q === null ? '-' : `${twoDec(q)}%`}</span></strong>
        </div>
        <div className={cellClassName(width, 'y', false)}>
          <span>{labels[lang].yUfk}: </span>
          <strong><span className={`${changeColor(y)}`}>{y === null ? '-' : `${twoDec(y)}%`}</span></strong>
        </div>
        <div className={cellClassName(width, 'y3', false)}>
          <span>{labels[lang].y3Ufk}: </span>
          <strong><span className={`${changeColor(y3)}`}>{y3 === null ? '-' : `${twoDec(y3)}%`}</span></strong>
        </div>
        <div className={cellClassName(width, 'y5', false)}>
          <span>{labels[lang].y5Ufk}: </span>
          <strong><span className={`${changeColor(y5)}`}>{y5 === null ? '-' : `${twoDec(y5)}%`}</span></strong>
        </div>
          { risk !== 0 && (
              <div className={cellClassName(width, 'risk', false)}>
                  <span>{labels[lang].riskUfk}: </span>
                  <strong><span>{labels[lang][riskObj[risk].label]}</span></strong>
              </div>
          )}
        <div className={cellClassName(width, 'csv', false)}><span>CSV: </span>
        <a data-content={labels[lang].downCSV} href={uri} target='_blank'>
            <i className="download icon"></i>
        </a>
        </div>
      </div>
    )
  }
}

type CompensaProps = {
    id: string,
    selected: boolean,
    name: string,
    valuation: number,
    sfdrLevel: ?number,
    lastValuationDate: Date,
    d: ?number,
    m: ?number,
    q: ?number,
    hy: ?number,
    y: ?number,
    y3: ?number,
    y5: ?number,
    ytd: ?number,
    max: ?number,
    disabled: boolean,
    lang: Lang,
    apiUrl: string,
    width: number,
    mode: Mode,
    addData: (ids: Array<string>, () => void) => void,
    removeData: (ids: Set<string>) => void
}

export class CompensaRow extends PureComponent<CompensaProps, State> {
    state = {
        checked: false,
        call: false
    }

    componentDidMount = () => {
        this.setState({ checked: this.props.selected})
    }

    componentWillReceiveProps ({ selected: checked }: CompensaProps) {
        checked !== this.state.checked && this.setState({ checked })
    }

    onChange = (e: SyntheticEvent<HTMLInputElement>) => {
        const { addData, removeData } = this.props
        const { name, checked } = e.currentTarget
        if (checked) {
            this.setState({ checked, call: true })
            addData([name], () => {
                this.setState({ call: false })
            })
        } else {
            this.setState({ checked })
            removeData(new Set([name]))
        }
    }

    render () {
        const { id, name, currency, sfdrLevel, category, valuation, lastValuationDate, recent, y, y3, y5, max, uri, disabled, lang, apiUrl, width, grouped } = this.props
        const { checked, call } = this.state
        return (
            <tr>
                <CheckboxCell
                    name={id}
                    onChange={this.onChange}
                    checked={checked}
                    disabled={disabled || call}
                    lang={lang}
                />
                <NameCompensaCell
                    content={name}
                    {...{ id, currency, sfdrLevel, valuation, lastValuationDate, recent, y, y3, y5, max, lang, uri, width} }
                />
                <CustomCell content={category} className={grouped ? 'hide' : cellClassName(width, 'cat')} />
                <CustomCell content={moment(lastValuationDate).format('L')} className={cellClassName(width, 'lastValuationDate')} />
                <FundValueCell num={valuation} lang={lang} className={cellClassName(width, 'val')} />
                <NumberCell num={recent} percent className={cellClassName(width, 'recent')} />
                <NumberCell num={y} percent className={cellClassName(width, 'y')} />
                <NumberCell num={y3} percent className={cellClassName(width, 'y3')} />
                <NumberCell num={y5} percent className={cellClassName(width, 'y5')} />
                <NumberCell num={max} percent className={cellClassName(width, 'max')} />
                <CustomCell
                    icon
                    uri={`${apiUrl}fund/${id}?format=csv`}
                    className={cellClassName(width, 'csv')}
                    content="download"
                    textAlign="center"
                    popup={labels[lang].downCSV}
                />
            </tr>
        )
    }
}

type NameCompensaProps = {
    id: string,
    content: string,
    uri?: string,
    lang: Lang,
    valuation: number,
    lastValuationDate: Date,
    recent: ?number,
    y: ?number,
    y3: ?number,
    y5: ?number,
    max: ?number,
    apiUrl: string,
    width: number,
}

type NameCompensaState = {
    displayInfo: boolean
}

export class NameCompensaCell extends PureComponent<NameCompensaProps, NameCompensaState> {
    state = {
        displayInfo: false
    }
    manageDisplayInfo = () => {
        const { displayInfo } = this.state
        this.setState({ displayInfo: !displayInfo })
    }

    renderLeaves() {
        const { sfdrLevel } = this.props;
        const renderLeaves = [];
        for (let i = 0; i < sfdrLevel; i++) {
            renderLeaves.push(<Leaf key={i}/>);
        }
        return renderLeaves;
    }

    render () {
        const { id, content, uri = '', currency, valuation, lastValuationDate, recent, y, y3, y5, max, lang, apiUrl, width} = this.props
        const { displayInfo } = this.state
        const currencySuffix = content.includes('(EUR)') || content.includes('(PLN hedged)')
            ? ''
            : ' (' + currency + ')';
        return (
            <td className={`left aligned name-cell ${cellClassName(width, 'name')}`}>
                {uri
                    ? <Tooltip title={labels[lang].showDet}>
                        <a
                            href={uri}
                            target='_blank'
                            style={{color: "black"}}
                        >
                          <span style={{color: "black", "margin-right": "0.5rem"}}>
                            {content}
                          </span>
                            <i aria-hidden="true" className="external icon" style={{color: "#eb1e82"}}></i>
                        </a>
                    </Tooltip>
                    : content + currencySuffix}
                {/*{this.renderLeaves()}*/}
                {width < 1200
                    && <i
                        aria-hidden="true"
                        className={`${displayInfo ? 'minus square outline' : 'plus square outline'} link large icon plus-icon`}
                        onClick={this.manageDisplayInfo}>
                    </i>}
                <InfoCompensaCell {...{ valuation, lastValuationDate, recent, y, y3, y5, max, lang, width, display: displayInfo, uri: `${apiUrl}fund/${id}?format=csv`}}/>
            </td>
        )
    }
}

type InfoCompensaProps = {
    lang: Lang,
    recent: ?number,
    y: ?number,
    y3: ?number,
    y5: ?number,
    max: ?number,
    display: boolean,
    uri: string,
    width: number
}

export class InfoCompensaCell extends PureComponent<InfoCompensaProps> {
    render () {
        const { lastValuationDate, recent, y, y3, y5, max, lang, display, width, uri} = this.props
        return (
            <div className={`info${display ? ' display' : ''}`}>
                <div className={cellClassName(width, 'recent', false)}>
                    <span>{labels[lang].dCompensa}: </span>
                    <strong><span className={`${changeColor(recent)}`}>{recent === null ? '-' : `${twoDec(recent)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'y', false)}>
                    <span>{labels[lang].yCompensa}: </span>
                    <strong><span className={`${changeColor(y)}`}>{y === null ? '-' : `${twoDec(y)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'y3', false)}>
                    <span>{labels[lang].y3Compensa}: </span>
                    <strong><span className={`${changeColor(y3)}`}>{y3 === null ? '-' : `${twoDec(y3)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'y5', false)}>
                    <span>{labels[lang].y5Compensa}: </span>
                    <strong><span className={`${changeColor(y5)}`}>{y5 === null ? '-' : `${twoDec(y5)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'max', false)}>
                    <span>{labels[lang].maxCompensa}: </span>
                    <strong><span className={`${changeColor(max)}`}>{max === null ? '-' : `${twoDec(max)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'csv', false)}><span>CSV: </span>
                    <a data-content={labels[lang].downCSV} href={uri} target='_blank'>
                        <i className="download icon"></i>
                    </a>
                </div>
            </div>
        )
    }
}

type ViennaProps = {
    id: string,
    selected: boolean,
    name: string,
    valuation: number,
    lastValuationDate: Date,
    category: string,
    currency: string,
    code: string,
    d: ?number,
    m: ?number,
    q: ?number,
    hy: ?number,
    y: ?number,
    y3: ?number,
    y5: ?number,
    ytd: ?number,
    max: ?number,
    disabled: boolean,
    risk: number,
    lang: Lang,
    apiUrl: string,
    width: number,
    grouped: 0 | 1,
    sfdrLevel: ?number,
    mode: Mode,
    addData: (ids: Array<string>, () => void) => void,
    removeData: (ids: Set<string>) => void,
}

export class ViennaRow extends PureComponent<ViennaProps, State> {
    state = {
        checked: false,
        call: false
    }

    componentDidMount = () => {
        this.setState({ checked: this.props.selected})
    }

    componentWillReceiveProps ({ selected: checked }: ViennaProps) {
        checked !== this.state.checked && this.setState({ checked })
    }

    onChange = (e: SyntheticEvent<HTMLInputElement>) => {
        const { addData, removeData } = this.props
        const { name, checked } = e.currentTarget
        if (checked) {
            this.setState({ checked, call: true })
            addData([name], () => {
                this.setState({ call: false })
            })
        } else {
            this.setState({ checked })
            removeData(new Set([name]))
        }
    }

    render () {
        const { id, name, code, currency, sfdrLevel, category, valuation, lastValuationDate, d, m, q, hy, y, y3, y5, ytd, max, uri, risk, disabled, lang, apiUrl, width, grouped, mode } = this.props
        const { checked, call } = this.state
        return (
            <tr>
                <CheckboxCell
                    name={id}
                    onChange={this.onChange}
                    checked={checked}
                    disabled={disabled || call}
                    lang={lang}
                />
                <NameViennaCell
                    content={name}
                    {...{ id, valuation, sfdrLevel, lastValuationDate, d, m, q, hy, y, y3, y5, ytd, risk, uri, max, lang, apiUrl, width, currency} }
                />
                <CodeViennaCell content={code} currency={currency} className={cellClassName(width, 'code')} />
                <CustomCell content={category} className={grouped ? 'hide' : cellClassName(width, 'cat')} />
                <CustomCell content={moment(lastValuationDate).format('L')} className={cellClassName(width, 'lastValuationDate')} />
                <FundValueCell num={valuation} lang={lang} className={cellClassName(width, 'val')} />
                <NumberCell num={d} percent className={cellClassName(width, 'd')} />
                <NumberCell num={m} percent className={cellClassName(width, 'm')} />
                <NumberCell num={q} percent className={cellClassName(width, 'q')} />
                <NumberCell num={hy} percent className={cellClassName(width, 'hy')} />
                <NumberCell num={y} percent className={cellClassName(width, 'y')} />
                <NumberCell num={y3} percent className={cellClassName(width, 'y3')} />
                <NumberCell num={y5} percent className={cellClassName(width, 'y5')} />
                <NumberCell num={ytd} percent className={cellClassName(width, 'ytd')} />
                <RiskCell num={risk} lang={lang} mode={mode} className={cellClassName(width, 'risk')} />
                <CustomCell
                    icon
                    uri={`${apiUrl}fund/${id}?format=csv`}
                    className={cellClassName(width, 'csv')}
                    content="download"
                    textAlign="center"
                    popup={labels[lang].downCSV}
                />
            </tr>
        )
    }
}

type NameViennaProps = {
    id: string,
    content: string,
    uri?: string,
    lang: Lang,
    valuation: number,
    lastValuationDate: Date,
    sfdrLevel: ?number,
    d: ?number,
    m: ?number,
    q: ?number,
    hy: ?number,
    y: ?number,
    y3: ?number,
    y5: ?number,
    ytd: ?number,
    max: ?number,
    apiUrl: string,
    currency: string,
    width: number,
}

type NameViennaState = {
    displayInfo: boolean
}

export class NameViennaCell extends PureComponent<NameViennaProps, NameViennaState> {
    state = {
        displayInfo: false
    }
    manageDisplayInfo = () => {
        const { displayInfo } = this.state
        this.setState({ displayInfo: !displayInfo })
    }

    renderLeaves() {
        const { sfdrLevel } = this.props;
        const renderLeaves = [];
        for (let i = 0; i < sfdrLevel; i++) {
            renderLeaves.push(<Leaf key={i}/>);
        }
        return renderLeaves;
    }

    render () {
        const { id, content, uri = '', valuation, lastValuationDate, d, m, q, hy, y, y3, y5, ytd, max, lang, currency, apiUrl, width} = this.props
        const { displayInfo } = this.state
        return (
            <td className={`left aligned name-cell ${cellClassName(width, 'name')}`}>
                {uri
                    ? <Tooltip title={labels[lang].showDet}>
                        <a
                            href={uri}
                            target='_blank'
                            style={{color: "black"}}
                        >
                            <span style={{color: "black", "margin-right": "0.5rem"}}>
                              {content}
                            </span>
                            <i aria-hidden="true" className="external icon" style={{color: "#eb1e82"}}></i>
                        </a>
                    </Tooltip>
                    : content + ' (' + currency + ')'}
                {/*{this.renderLeaves()}*/}
                {width < 1200
                    && <i
                        aria-hidden="true"
                        className={`${displayInfo ? 'minus square outline' : 'plus square outline'} link large icon plus-icon`}
                        onClick={this.manageDisplayInfo}>
                    </i>}
                <InfoViennaCell {...{ valuation, lastValuationDate, d, m, q, hy, y, y3, y5, ytd, max, lang, width, display: displayInfo, uri: `${apiUrl}fund/${id}?format=csv`}}/>
            </td>
        )
    }
}

type CodeViennaProps = {
    content: string,
    textAlign?: 'left' | 'center' | 'right',
    uri?: string,
    icon?: boolean,
    popup?: string,
    className?: string
}

export class CodeViennaCell extends PureComponent<CodeViennaProps> {
    render () {
        const { content, currency, textAlign = 'left', uri = '', icon = false, popup = '', className = '' } = this.props
        let con: Node = content
        if (icon && uri) {
            con = <a href={uri} target='_blank'><i className={`${content} icon`}></i></a>
        } else if (icon) {
            con = <i className={`${content} icon`}></i>
        } else if (uri) {
            con = <a href={uri} target='_blank'>{content}</a>
        }

        return (
            popup
                ? <Tooltip title={popup}>
                    <td className={`${className} ${textAlign} aligned`}>
                        {con}
                    </td>
                </Tooltip>
                : <td
                    className={`${className} ${textAlign} aligned`}>
                    {con}
                    {(currency === 'USD') && <sup> (2)</sup>}
                    {(currency === 'EUR') && <sup> (1)</sup>}
                </td>
        )
    }
}


type InfoViennaProps = {
    lang: Lang,
    d: ?number,
    m: ?number,
    q: ?number,
    hy: ?number,
    y: ?number,
    y3: ?number,
    y5: ?number,
    ytd: ?number,
    max: ?number,
    display: boolean,
    uri: string,
    width: number
}

export class InfoViennaCell extends PureComponent<InfoViennaProps> {
    render () {
        const { lastValuationDate, d, m, q, hy, y, y3, y5, ytd, max, lang, display, width, uri} = this.props
        return (
            <div className={`info${display ? ' display' : ''}`}>
                <div className={cellClassName(width, 'm', false)}>
                    <span>{labels[lang].lastValuationDateVienna}: </span>
                    <strong><span className={`${changeColor(lastValuationDate)}`}>{lastValuationDate === null ? '-' : moment(lastValuationDate).format('L')}</span></strong>
                </div>
                <div className={cellClassName(width, 'd', false)}>
                    <span>{labels[lang].dVienna}: </span>
                    <strong><span className={`${changeColor(d)}`}>{d === null ? '-' : `${twoDec(d)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'm', false)}>
                    <span>{labels[lang].mVienna}: </span>
                    <strong><span className={`${changeColor(m)}`}>{m === null ? '-' : `${twoDec(m)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'q', false)}>
                    <span>{labels[lang].qVienna}: </span>
                    <strong><span className={`${changeColor(q)}`}>{q === null ? '-' : `${twoDec(q)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'hy', false)}>
                    <span>{labels[lang].hyVienna}: </span>
                    <strong><span className={`${changeColor(hy)}`}>{hy === null ? '-' : `${twoDec(hy)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'y', false)}>
                    <span>{labels[lang].yVienna}: </span>
                    <strong><span className={`${changeColor(y)}`}>{y === null ? '-' : `${twoDec(y)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'y3', false)}>
                    <span>{labels[lang].y3Vienna}: </span>
                    <strong><span className={`${changeColor(y3)}`}>{y3 === null ? '-' : `${twoDec(y3)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'y5', false)}>
                    <span>{labels[lang].y5Vienna}: </span>
                    <strong><span className={`${changeColor(y5)}`}>{y5 === null ? '-' : `${twoDec(y5)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'ytd', false)}>
                    <span>{labels[lang].ytdVienna}: </span>
                    <strong><span className={`${changeColor(ytd)}`}>{ytd === null ? '-' : `${twoDec(ytd)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'max', false)}>
                    <span>{labels[lang].maxVienna}: </span>
                    <strong><span className={`${changeColor(max)}`}>{max === null ? '-' : `${twoDec(max)}%`}</span></strong>
                </div>
                <div className={cellClassName(width, 'csv', false)}><span>CSV: </span>
                    <a data-content={labels[lang].downCSV} href={uri} target='_blank'>
                        <i className="download icon"></i>
                    </a>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/ListRow.js